import React, { Component } from "react";
import { Link } from 'react-router-dom';

class EthicsMember extends Component {
  render() {
    return (
    <div>
      <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">รู้จักสหกรณ์</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="ethicsmember" className="a-breadcrumbs">จรรยาบรรณ 6 ประการ สำหรับสมาชิกสหกรณ์</a>
              </div>
            </div>
          </div>
        </section>
        <section className="page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-sm-9 mb-sm-50">
                <h2 className="title-section mt-0 mb-0"><span>จรรยาบรรณ 6 ประการ สำหรับสมาชิกสหกรณ์</span></h2><br/>
                <div class="divider gray left mt-20 mb-30"></div>

                  <p className="mb-30" style={{fontSize: 20}}>
                    1.	มุ่งมั่นและอุทิศเพื่อพัฒนาให้สหกรณ์ก้าวหน้า โดยยึดมั่น อุดมการณ์ หลักการและวิธีการสหกรณ์ <br />
                    2.	ปฏิบัติตามกฎหมาย ข้อบังคับ ระเบียบของสหกรณ์อย่างเคร่งครัด <br />
                    3.	สอดส่องดูแลและส่งเสริมสนับสนุนกิจการของสหกรณ์เพื่อให้สหกรณ์เป็นองค์กรที่เข้มแข็ง <br />
                    4.	ร่วมทำธุรกิจของสหกรณ์ ในฐานะเจ้าของสหกรณ์ <br />
                    5.	ร่วมมือกับคณะกรรมการดำเนินการของสหกรณ์ พัฒนาสหกรณ์ให้เจริญรุ่งเรืองมั่นคง <br />
                    6.	มุ่งมั่น ดำรงชีวิตตามหลักปรัชญาเศรษฐกิจพอเพียง
                  </p>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
              </div>
            </div>
          </div>
        </section>

      </div>
      );
  }
}

export default EthicsMember;
